module.exports = __webpack_public_path__ + "static/media/DSC04213.38f373a6.JPG";